import React from 'react';

/**
 * Centered status block: loading, empty, error, or any icon + title + subtitle.
 */
const StatusMessage = ({ icon: Icon, title, subtitle, iconClassName }) => (
  <div className="flex flex-col items-center justify-center py-16 gap-3">
    <Icon className={`h-8 w-8 text-content-muted ${iconClassName ?? ''}`} />
    <span className="text-sm font-medium text-content-secondary">{title}</span>
    <span className="text-xs text-content-muted">{subtitle}</span>
  </div>
);

export default StatusMessage;
